<template>
    <footer>
        <div id="footer" class="footer">
            <v-btn id="faq-button" fab color="secondary" absolute class="faq-button" @click.stop="showContextHelp = !showContextHelp">
                <v-icon>$vuetify.icon.questionCircle</v-icon>
            </v-btn>
        </div>
        <FAQDrawer v-model="showContextHelp">
        </FAQDrawer>
    </footer>
</template>

<script>
    import FAQDrawer from "@/components/drawer/FAQDrawer.vue";

    export default {
        components: {FAQDrawer},

        data() {
            return {
                showContextHelp: false,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .footer {
        position: fixed;
        right: 0;
        padding-right: 5vw;
        bottom: 100px;
        display: flex;
        justify-content: flex-end;
        align-content: flex-end;
        align-items: flex-end;
        width: 95%;
        margin: auto;
    }

    @media only screen and (max-width: 960px) {
        .footer {
            display: none;
        }
    }

    .faq-button {
        margin: auto;
    }

    .navigation-drawer {
        width: 560px !important;
        position: fixed;
        top: 0;
        right: 0;
        overflow-y: scroll;
    }

    .v-btn--fab.v-size--default {
        background: #fff !important;
        color: $secondary-color !important;
        min-height: rem(56px) !important;
    }

    .v-btn--fab.v-size--default {
        background: #fff !important;
        color: $secondary-color !important;
        min-height: rem(56px) !important;
    }

    .v-overlay__scrim {
        height: 100%;
    }

</style>
